module.exports = __webpack_public_path__ + "img/banner.decebcc2.png";